import { Container, Divider, Grid } from "@mui/material";
import Skeleton from "../../../common/skeleton/skeleton";

function TourSkeleton() {
    return (
        <Container maxWidth="xl">
            <Grid container item xs={12} rowGap={{ xs: 2, md: 5 }}>
                <Grid container item xs={12} justifyContent="space-between" alignItems="center">
                    <Skeleton variant="text" animation="wave" width={100} height={20} />
                    <Divider width="90%" />
                </Grid>

                <Grid className="base-sort" container item xs={12} md="auto" columnGap={2} display={{ xs: "none", md: "flex" }}>
                    {[...Array(4)].map((_, index) => (
                        <Grid key={index} container item xs="auto">
                            <Skeleton variant="text" animation="wave" width={100} height={20} />
                        </Grid>
                    ))}
                </Grid>

                <Grid container item xs={12} rowGap={3} columnGap={3}>
                    {[...Array(8)]?.map((_, index) => {
                        return (
                            <Grid key={index} className="tour-item" container item md={2.85} rowGap={1}>
                                <Skeleton variant="rounded" animation="wave" width="100%" height={150} />
                                <Skeleton variant="rounded" animation="wave" width="100%" height={30} />
                                <Skeleton variant="rounded" animation="wave" width="100%" height={30} />
                                <Skeleton variant="rounded" animation="wave" width="100%" height={30} />
                            </Grid>
                        );
                    })}
                </Grid>
            </Grid>
        </Container>
    );
}

export default TourSkeleton;
